module.exports = __webpack_public_path__ + "static/media/global.165480c0.svg";